(function(){
  /**
   * Service wrapping the standardscompletions endpoint
   */
  angular.module('edxComponents').factory('edxStandardsCompletionService', [
    'cancelableResourceFactory',
    'cancelableResourceManager',
    'edxSnakeToCamelService',
    StandardsCompletionServiceFactory]);

  function AstCompletion(props) {
    _.assign(this, props);
  }

  function LevelCompletion(props) {
    _.assign(this, props);
  }

  function StandardsCompletionServiceFactory(
    $cancelableResourceFactory,
    $cancelableResourceManager,
    snakeToCamelService) {

    var cachedPromise, cacheKey, cacheExpiration;
    var ttlMillis = 10000;

    var Resource = $cancelableResourceFactory.createCacheableResource(null, '/api/v1/districts/:districtId/standardscompletions', { }, {
      get: {
        url: '/api/v1/districts/:districtId/standardscompletions',
        method: 'GET',
        transformResponse: function(body) {
          return snakeToCamelService.snakeToCamel(JSON.parse(body), true);
        }
      }
    });

    return {
      getAstCompletionForStudent: getAstCompletionForStudent,
      getLevelCompletionsForStudent: getLevelCompletionsForStudent,
      getLevelCompletionForStudent: getLevelCompletionForStudent,
      collapsePseudoClustersInLevel: collapsePseudoClustersInLevel,
      isPseudoCluster: isPseudoCluster,
      setCacheTtlMillis: setCacheTtlMillis
    };

    /**
     * Set cache TTL for future calls.
     *
     * @param millis
     */
    function setCacheTtlMillis(millis) {
      ttlMillis = millis;
    }

    /**
     * Get completion info for just the AST with no breakdown.
     *
     * @param districtId ID of district for student
     * @param userId ID of student
     * @param ast Name of the AST
     */
    function getAstCompletionForStudent(districtId, userId, ast) {
      return _getStandardsCompletionForStudent(districtId, userId, ast).then(function(props){
        delete props.levelCompletions;
        return new AstCompletion(props);
      });
    }

    /**
     * Get completion info for a single AST level.
     *
     * The result includes domain, cluster, standard breakdown.
     *
     * @param districtId ID of district for student
     * @param userId ID of student
     * @param ast Name of the AST
     * @param levelCode Code for the level
     */
    function getLevelCompletionForStudent(districtId, userId, ast, levelCode) {
      return _getStandardsCompletionForStudent(districtId, userId, ast).then(function(props){
        var level = _.find(props.levelCompletions, function(lvl){
          return lvl.code === levelCode;
        });
        if (level) {
          return new LevelCompletion(level);
        } else {
          return undefined;
        }
      });
    }

    /**
     * Get completion info for all levels in AST.
     *
     * The result does not include domain, cluster, standard breakdown.
     *
     * @param districtId
     * @param userId
     * @param ast
     */
    function getLevelCompletionsForStudent(districtId, userId, ast) {
      return _getStandardsCompletionForStudent(districtId, userId, ast).then(function(props){
        return _.map(props.levelCompletions, function(level){
          delete level.domains;
          return new LevelCompletion(level);
        });
      });
    }

    function _getStandardsCompletionForStudent(districtId, userId, ast) {
      var promise = _getStandardsCompletionForStudentFromCache(districtId, userId, ast);
      if (!promise) {
        promise = _getStandardsCompletionForStudentFromResource(districtId, userId, ast);
        _cacheGetStandardsCompletionForStudent(promise, districtId, userId, ast);
      }
      return promise.then(function(props){
        return _.cloneDeep(props);
      });
    }

    function _getStandardsCompletionForStudentFromResource(districtId, userId, ast) {
      var h = Resource.get({
        districtId: districtId,
        userId: userId,
        ast: ast
      });
      $cancelableResourceManager.addAndRemoveOnFinish(h);
      return h.$promise.then(function(response){
        return response.data[0];
      });
    }

    function _getStandardsCompletionForStudentFromCache(districtId, userId, ast) {
      if (!cachedPromise) {
        return undefined;
      }

      var key = _createCacheKey(districtId, userId, ast);
      if (key !== cacheKey) {
        return undefined;
      }

      var cm = _currentMillis();
      if (cm > cacheExpiration) {
        return undefined;
      }

      return cachedPromise;
    }

    function _cacheGetStandardsCompletionForStudent(promise, districtId, userId, ast) {
      promise.catch(function(){
        if (cachedPromise === promise) {
          cachedPromise = undefined;
        }
      });
      cachedPromise = promise;
      cacheKey = _createCacheKey(districtId, userId, ast);
      cacheExpiration = _currentMillis() + 10000;
    }

    /**
     * Domains can have multiple pseudo-clusters.  It can be more convenient to combine all of the nested standards
     * into a single pseudo-cluster.  This replaces all of the pseudo clusters in each domain with a single
     * pseudo cluster, combining all of the standards completions.
     *
     * @param level
     * @return {*}
     */
    function collapsePseudoClustersInLevel(level) {
      _.forEach(level.domains, function(domain){
        _collapsePseudoClustersInDomain(domain);
      });
      return level;
    }

    function _collapsePseudoClustersInDomain(domain) {
      var standards = [];
      _.forEach(domain.clusters, function(cluster){
        if (isPseudoCluster(cluster)) {
          standards = standards.concat(cluster.standards);
        }
      });
      domain.clusters = _.filter(domain.clusters, function(cluster){
        return !isPseudoCluster(cluster);
      });
      if (standards.length > 0) {
        domain.clusters.push({name: '---', standards: standards});
      }
    }

    /**
     * Determine if a cluster is actually a pseudo cluster.
     *
     * @param cluster Cluster to test
     * @return {boolean} true if cluster is a pseudo cluster
     */
    function isPseudoCluster(cluster) {
      return cluster.name === '---';
    }

    function _createCacheKey(districtId, userId, ast) {
      return '' + districtId + '-' + userId + '-' + ast;
    }

    function _currentMillis() {
      return +Date.now() - 1521586072408;
    }

  }
})();